import classNames from "classnames";
import { Form, Formik } from "formik";
import React from "react";
import style from "../../assets/css/components/Form/Form.module.css";
import Button from "../Button/Button";
import InputSelect from "../Input/InputSelect";

import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

import { socket } from "../../config/socket";
import { AddExtraPointInitialState, AddExtraPointValidationSchema } from "../../utils/extrapoint";
const MySwal = withReactContent(Swal);

function FormPuntoExtra({ idMatch, teams }) {
  const handleSubmit = async (values) => {
    // console.log(values);
    const { team } = values;

    socket.emit("extraPoint", { idMatch, team }, (match) => {
      MySwal.fire("punto extra agregado");
      // console.log(match);
    });
  };

  return (
    <Formik
      initialValues={AddExtraPointInitialState}
      validationSchema={AddExtraPointValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, handleChange, touched, values }) => (
        <Form className={classNames(style.form, style.formLive)}>
          <div className={classNames(style.formColumn, style.twoColumn)}>
            <InputSelect
              error={touched.team && errors.team}
              name="team"
              title={"Punto extra para"}
              options={teams}
              onChange={(selectedOption) => {
                handleChange("team")(selectedOption.value);
              }}
            />
          </div>
          <Button text="Guardar" />
        </Form>
      )}
    </Formik>
  );
}

export default FormPuntoExtra;
